import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {FormGroup, Icon, Switch} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import SelectRecipients from '../../../SelectRecipients';
import {IUser} from '../../../../models';

import './SendNotification.scss';

interface SelectNotificationTypeProps {
  data?: any;
}

interface SelectNotificationRecipientsProps {
  data?: any;
  users: IUser[];
  currentUser: IUser | null | undefined;
  edit: boolean;
}

export const SelectNotificationType = forwardRef(({
  data,
}: SelectNotificationTypeProps, ref: any) => {
  const [onSuccess, setOnSuccess] = useState<boolean>(false);
  const [onFailed, setOnFailed] = useState<boolean>(true);

  useEffect(() => {
    if (data) {
      setOnSuccess(data?.success || false);
      setOnFailed(data?.failed || false);
    }
  }, [data]);

  const onCheckboxChange =
    (setFn: Function) =>
      (event: React.FormEvent<HTMLInputElement>) => {
        setFn(event.currentTarget.checked);
  }

  useImperativeHandle(ref, () => ({
    getValue() {
      return {
        success: onSuccess,
        failed: onFailed,
      };
    }
  }));

  return (
    <FormGroup label={
      <>
        <Icon icon={IconNames.NOTIFICATIONS} /> Send notification after scheduled run
      </>
      }
      className="trigger-dialog__notification"
    >
      <Switch
        label="Error Notifications"
        name="failed"
        checked={onFailed}
        onChange={onCheckboxChange(setOnFailed)}
        inline={true}
      />
      <Switch
        label="Success Notifications"
        name="success"
        checked={onSuccess}
        onChange={onCheckboxChange(setOnSuccess)}
        inline={true}
      />
    </FormGroup>
  );
});

export const SelectNotificationRecipients = forwardRef(({
  data,
  users,
  currentUser,
  edit,
}: SelectNotificationRecipientsProps, ref: any) => {
  const [recipients, setRecipients] = useState<string[]>();
  const showRecipients = !edit || (edit && !!recipients);

  useEffect(() => {
    if (data) {
      setRecipients(data.recipients_json);
    } else {
      /*
       * if no data (new schedule) default recipients to current user
       */
      setRecipients([currentUser?.email as string]);
    }
  }, [data]);

  if (!showRecipients) {
    return null;
  }

  return (
    <SelectRecipients
      ref={ref}
      defaultValue={recipients}
      onChange={setRecipients}
    />
  );
});
